import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getProductMaster,
  getIdProductMaster,
  createProductMaster,
  updateProductMaster,
  deleteProductMaster,
  getColorMaster,
  getIdColorMaster,
  createColorMaster,
  updateColorMaster,
  deleteColorMaster,
  getModelMaster,
  getIdModelMaster,
  createModelMaster,
  updateModelMaster,
  deleteModelMaster,
  createDuplicateProductMaster,
  getProductMasterMaster,
} from "./productRelatedAPI";

const initialState = {
  data: [],
  dataId: null,
  dataColor: [],
  dataIdColor: null,
  dataModel: [],
  dataIdModel: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  pageNoModel: 1,
  pageSizeModel: 10,
  totalRecordModel: 0,
  pageNoColor: 1,
  pageSizeColor: 10,
  totalRecordColor: 0,
  selected: null,
  result: null,
  permissionProduct: [],
  permissionModel: [],
  permissionColor: [],
};

export const fetchProductMaster = createAsyncThunk(
  "ProductMaster/fetchProductMaster",
  async (payload) => {
    const response = await getProductMaster(payload);
    return response;
  }
);

export const fetchProductMasterMaster = createAsyncThunk(
  "ProductMaster/fetchProductMasterMaster",
  async (payload) => {
    const response = await getProductMasterMaster(payload);
    return response;
  }
);

export const addProductMaster = createAsyncThunk(
  "ProductMaster/addProductMaster",
  async (payload) => {
    const response = await createProductMaster(payload);
    return response;
  }
);
export const duplicateProductMaster = createAsyncThunk(
  "ProductMaster/duplicateProductMaster",
  async (payload) => {
    const response = await createDuplicateProductMaster(payload);
    return response;
  }
);

export const editProductMaster = createAsyncThunk(
  "ProductMaster/editProductMaster",
  async (payload) => {
    const response = await updateProductMaster(payload);
    return response;
  }
);

export const fetchIdProductMaster = createAsyncThunk(
  "ProductMaster/fetchIdProductMaster",
  async (id) => {
    const response = await getIdProductMaster(id);
    return response;
  }
);

export const removeProductMaster = createAsyncThunk(
  "ProductMaster/removeProductMaster",
  async (payload) => {
    const response = await deleteProductMaster(payload);
    return response;
  }
);

// colormaster

export const fetchColorMaster = createAsyncThunk(
  "ColorMaster/fetchColorMaster",
  async (payload) => {
    const response = await getColorMaster(payload);
    return response;
  }
);
export const fetchColorMaster2 = createAsyncThunk(
  "ColorMaster/fetchColorMaster2",
  async (payload) => {
    const response = await getColorMaster(payload);
    return response;
  }
);

export const addColorMaster = createAsyncThunk(
  "ColorMaster/addColorMaster",
  async (payload) => {
    const response = await createColorMaster(payload);
    return response;
  }
);

export const editColorMaster = createAsyncThunk(
  "ColorMaster/editColorMaster",
  async (payload) => {
    const response = await updateColorMaster(payload);
    return response;
  }
);

export const fetchIdColorMaster = createAsyncThunk(
  "ColorMaster/fetchIdColorMaster",
  async (id) => {
    const response = await getIdColorMaster(id);
    return response;
  }
);

export const removeColorMaster = createAsyncThunk(
  "ColorMaster/removeColorMaster",
  async (payload) => {
    const response = await deleteColorMaster(payload);
    return response;
  }
);

// Model master

export const fetchModelMaster = createAsyncThunk(
  "ModelMaster/fetchModelMaster",
  async (payload) => {
    const response = await getModelMaster(payload);
    return response;
  }
);
export const fetchModelMaster2 = createAsyncThunk(
  "ModelMaster/fetchModelMaster2",
  async (payload) => {
    const response = await getModelMaster(payload);
    return response;
  }
);

export const addModelMaster = createAsyncThunk(
  "ModelMaster/addModelMaster",
  async (payload) => {
    const response = await createModelMaster(payload);
    return response;
  }
);

export const editModelMaster = createAsyncThunk(
  "ModelMaster/editModelMaster",
  async (payload) => {
    const response = await updateModelMaster(payload);
    return response;
  }
);

export const fetchIdModelMaster = createAsyncThunk(
  "ModelMaster/fetchIdModelMaster",
  async (id) => {
    const response = await getIdModelMaster(id);
    return response;
  }
);

export const removeModelMaster = createAsyncThunk(
  "ModelMaster/removeModelMaster",
  async (payload) => {
    const response = await deleteModelMaster(payload);
    return response;
  }
);

export const productRelatedSlice = createSlice({
  name: "productRelated",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermissionProduct: (state, action) => {
      state.permissionProduct = action.payload;
    },
    setPermissionModel: (state, action) => {
      state.permissionModel = action.payload;
    },
    setPermissionColor: (state, action) => {
      state.permissionColor = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchProductMasterMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductMasterMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdProductMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdProductMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addProductMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(addProductMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(duplicateProductMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(duplicateProductMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editProductMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(editProductMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeProductMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeProductMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // colorMaster
      .addCase(fetchColorMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchColorMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.dataColor = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchColorMaster2.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchColorMaster2.fulfilled, (state, action) => {
        state.loading = false;
        state.dataColor = action.payload.data.data;
        state.pageNoColor = action.payload.data.pageNo;
        state.pageSizeColor = action.payload.data.pageSize;
        state.totalRecordColor = action.payload.data.totalRecord;
      })
      .addCase(fetchIdColorMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdColorMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addColorMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(addColorMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editColorMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(editColorMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeColorMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeColorMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // ModelMaster
      .addCase(fetchModelMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchModelMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.dataModel = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchModelMaster2.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchModelMaster2.fulfilled, (state, action) => {
        state.loading = false;
        state.dataModel = action.payload.data.data;
        state.pageNoModel = action.payload.data.pageNo;
        state.pageSizeModel = action.payload.data.pageSize;
        state.totalRecordModel = action.payload.data.totalRecord;
      })
      .addCase(fetchIdModelMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdModelMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addModelMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(addModelMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editModelMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(editModelMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeModelMaster.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeModelMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermissionColor,
  setPermissionModel,
  setPermissionProduct,
} = productRelatedSlice.actions;

export const selectProductMaster = (state) => state.productRelated.data;
export const selectIdProductMaster = (state) => state.productRelated.dataId;
export const selectColorMaster = (state) => state.productRelated.dataColor;
export const selectIdColorMaster = (state) => state.productRelated.dataIdColor;
export const selectModelMaster = (state) => state.productRelated.dataModel;
export const selectIdModelMaster = (state) => state.productRelated.dataIdModel;
export const selectLoading = (state) => state.productRelated.loading;
export const selectError = (state) => state.productRelated.error;
export const selectPageNo = (state) => state.productRelated.pageNo;
export const selectPageSize = (state) => state.productRelated.pageSize;
export const selectTotalRecord = (state) => state.productRelated.totalRecord;
export const selectSelected = (state) => state.productRelated.selected;
export const selectResult = (state) => state.productRelated.result;
export const selectPermissionProduct = (state) =>
  state.productRelated.permissionProduct;
export const selectPermissionModel = (state) =>
  state.productRelated.permissionModel;
export const selectPermissionColor = (state) =>
  state.productRelated.permissionColor;
export const selectPageNoModel = (state) => state.productRelated.pageNoModel;
export const selectPageSizeModel = (state) =>
  state.productRelated.pageSizeModel;
export const selectTotalRecordModel = (state) =>
  state.productRelated.totalRecordModel;
export const selectPageNoColor = (state) => state.productRelated.pageNoColor;
export const selectPageSizeColor = (state) =>
  state.productRelated.pageSizeColor;
export const selectTotalRecordColor = (state) =>
  state.productRelated.totalRecordColor;

export default productRelatedSlice.reducer;
